// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: packages/content/src/catalog/*.ts
import m0 from './catalog/fish';
import m1 from './catalog/floors';
import m2 from './catalog/fossils';
import m3 from './catalog/fruit';
import m4 from './catalog/furniture';
import m5 from './catalog/misc';
import m6 from './catalog/shells';
import m7 from './catalog/tools';
import m8 from './catalog/wallpaper';
import m9 from './catalog/world';
export const catalogModules = { fish: m0, floors: m1, fossils: m2, fruit: m3, furniture: m4, misc: m5, shells: m6, tools: m7, wallpaper: m8, world: m9 } as const;
